var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMysoLogoBigColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 150,
    viewBox: "0 0 160 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.754 0H32.7247C14.6513 0 0 14.6513 0 32.7247V117.275C0 135.349 14.6513 150 32.7247 150H126.754C144.827 150 159.479 135.349 159.479 117.275V32.7247C159.479 14.6513 144.827 0 126.754 0Z",
    fill: "url(#paint0_linear_191_6955)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.925 67.5041C107.582 66.8915 102.031 71.5046 101.419 77.8117C100.085 91.5791 88.6604 101.959 74.8209 101.959C60.0803 101.959 48.0789 89.9573 48.0789 75.2168C48.0789 74.8203 48.0068 74.4239 47.9708 74.0635L48.0429 74.1356C48.0429 74.1356 47.5383 66.3509 51.4307 62.3143L51.9352 61.7737C55.9717 57.557 60.5849 58.5301 63.6483 58.5301C67.2524 58.5301 70.9285 57.7012 73.6315 54.89C78.2807 50.0606 78.1366 42.384 73.3072 37.7348C68.4778 33.0856 60.8012 33.2298 56.1519 38.0592C53.4489 40.8703 52.9804 44.5464 52.9083 48.1865C52.8362 51.1779 53.2327 55.8271 49.989 59.8636L49.4845 60.4042C46.421 65.3057 37.8434 63.828 37.8434 63.828H37.8795C37.447 63.828 37.0505 63.7559 36.6181 63.7559C30.275 63.7559 25.1572 68.8737 25.1572 75.2168C25.1572 102.607 47.4302 124.88 74.8209 124.88C100.554 124.88 121.817 105.599 124.268 80.0102C124.881 73.7031 120.268 68.1168 113.961 67.5041H113.925Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.022 58.5299C119.689 58.5299 125.095 53.1238 125.095 46.4563C125.095 39.7889 119.689 34.3828 113.022 34.3828C106.354 34.3828 100.948 39.7889 100.948 46.4563C100.948 53.1238 106.354 58.5299 113.022 58.5299Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_6955",
    x1: 167.227,
    y1: 162.47,
    x2: -38.1307,
    y2: -42.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B027FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#585EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0097FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysoLogoBigColored);
export default __webpack_public_path__ + "static/media/mysoLogoBigColored.af213ecb3cd9fbf4b0d95d24cf16dda6.svg";
export { ForwardRef as ReactComponent };